import React, { useEffect, useState, useRef } from 'react';

const styles = {
  body: {
    fontFamily: "'Comic Sans MS', cursive",
    background: 'linear-gradient(to right, #fdfbfb, #ebedee)',
    textAlign: 'center',
    padding: '40px',
  },
  h1: {
    color: '#3f51b5',
    fontSize: '3rem',
  },
  numberDisplay: {
    fontSize: '6rem',
    color: '#ff5722',
    margin: '30px 0',
  },
  button: {
    fontSize: '2rem',
    padding: '15px 30px',
    margin: '15px',
    border: 'none',
    borderRadius: '12px',
    cursor: 'pointer',
    transition: '0.3s ease',
  },
  evenBtn: {
    backgroundColor: '#4caf50',
    color: 'white',
  },
  oddBtn: {
    backgroundColor: '#f44336',
    color: 'white',
  },
  feedback: {
    fontSize: '2rem',
    marginTop: '20px',
    color: '#333',
    height: '40px',
    fontWeight: 'bold',
  },
  scoreBoard: {
    margin: '20px 0',
    fontSize: '1.5rem',
    color: '#333',
  },
  stars: {
    fontSize: '2rem',
    color: 'gold',
  },
  timer: {
    fontSize: '1.8rem',
    color: '#d32f2f',
    marginBottom: '10px',
  },
};

export default function OddOrEvenGame() {
  const [number, setNumber] = useState('?');
  const [score, setScore] = useState(0);
  const [stars, setStars] = useState(1);
  const [feedback, setFeedback] = useState('');
  const [feedbackColor, setFeedbackColor] = useState('#333');
  const [timeLeft, setTimeLeft] = useState(30);
  const [gameOver, setGameOver] = useState(false);

  const correctSound = useRef(null);
  const wrongSound = useRef(null);

  useEffect(() => {
    generateNumber();
    const timerId = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timerId);
          setFeedback(`🎉 Time’s up! Final Score: ${score}`);
          setFeedbackColor('#333');
          setGameOver(true);
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timerId);
  }, []);

  const generateNumber = () => {
    const randNum = Math.floor(Math.random() * 100) + 1;
    setNumber(randNum);
    setFeedback('');
  };

  const checkAnswer = (clickedEven) => {
    const isEven = number % 2 === 0;
    if (clickedEven === isEven) {
      correctSound.current?.play();
      setFeedback('✅ Correct!');
      setFeedbackColor('#4caf50');
      const newScore = score + 1;
      setScore(newScore);
      if (newScore % 5 === 0) {
        setStars((prev) => prev + 1);
      }
    } else {
      wrongSound.current?.play();
      setFeedback('❌ Oops!');
      setFeedbackColor('#f44336');
    }
    generateNumber();
  };

  return (
    <div style={styles.body}>
      <h1 style={styles.h1}>🔢 Odd or Even?</h1>
      <div style={styles.timer}>⏱️ Time: {timeLeft}</div>
      <div style={styles.scoreBoard}>
        Score: <span>{score}</span> | Stars:{' '}
        <span style={styles.stars}>{'⭐'.repeat(stars)}</span>
      </div>
      <div style={styles.numberDisplay}>{number}</div>
      <button
        style={{ ...styles.button, ...styles.evenBtn }}
        onClick={() => checkAnswer(true)}
        disabled={gameOver}
      >
        ✅ Even
      </button>
      <button
        style={{ ...styles.button, ...styles.oddBtn }}
        onClick={() => checkAnswer(false)}
        disabled={gameOver}
      >
        ❌ Odd
      </button>
      <div style={{ ...styles.feedback, color: feedbackColor }}>{feedback}</div>
      <audio ref={correctSound} src="https://actions.google.com/sounds/v1/cartoon/clang_and_wobble.ogg" />
      <audio ref={wrongSound} src="https://actions.google.com/sounds/v1/cartoon/cartoon_boing.ogg" />
    </div>
  );
}
